import {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from '../types';
import packagesTypes from '../types/packages';
import initialPackagesState from '../states/packages';

export default (state = initialPackagesState, action) => {
  switch (action.type) {
    // GET_PACKAGES
    case asyncActionTypeRequest(packagesTypes.GET_PACKAGES):
      return {
        ...state,
        packages: { ...state.packages, loading: true, error: '' },
      };
    case asyncActionTypeSuccess(packagesTypes.GET_PACKAGES):
      return {
        ...state,
        packages: {
          loading: false,
          data: action.response?.data || [],
          error: '',
        },
      };
    case asyncActionTypeFailure(packagesTypes.GET_PACKAGES):
      return {
        ...state,
        packages: {
          loading: false,
          data: [],
          error: action.error || '',
        },
      };

    default:
      return state;
  }
};
